<template lang="pug">
v-sheet.rounded-xl(
  v-bind="cardAttrs"
)
  v-list-item.pa-0
    v-list-item-content
      .grey--text  Шапка договора:
    v-list-item-action
      slot(name="shapkaAction")

  .text-caption.error--text.pl-2.
    ВМЕСТО этих слов вставьте текст,
    который обычно используете для договоров, как {{ noChangedText }}
  v-textarea(
    v-model="firstValue"
    rounded filled
    auto-grow
    rows="2"
    row-height="20"
  )
    template(#append)
      .d-flex
        div: strong {{ noChangedText }}
  .text-caption.error--text.pl-2.
    ТУТ УКАЖИТЕ КТО и на основании ЧЕГО будет от вас подписывать договор, например
  v-textarea(
    v-model="secondValue"
    rounded filled hide-details
    auto-grow
    rows="2"
    row-height="20"
  )
</template>
<script>
export default {
  props: {
    value: { type: String, default: '' },
    noChangedText: { type: String, default: '«Исполнитель»,' },
    cardAttrs: { type: Object, default: () => {} },
  },
  data() {
    return {
      firstValue: '',
      secondValue: '',
      defaultValue: `Федеральное государственное бюджетное учреждение культуры «Всероссийский центр развития художественного творчества и гуманитарных технологий» (ФГБУК «ВЦХТ»), именуемое в дальнейшем ${this.noChangedText} в лице директора Гончаровой Оксаны Валерьевны, действующего на основании Устава`,
    };
  },
  computed: {
    returnValue() {
      return `${this.firstValue} ${this.noChangedText} ${this.secondValue}`;
    },
  },
  watch: {
    returnValue(val) {
      this.$emit('input', val);
    },
  },
  created() {
    const valueToSplit = this.value || this.defaultValue;
    const [first, second] = valueToSplit.split(this.noChangedText);
    this.firstValue = first;
    this.secondValue = second;
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-input__append-inner {
  align-self: flex-end !important;
  padding-bottom: 10px;
}
</style>
